<template style="height: 100%;">
  <div class="Waiting_test CommonContentSingle-white">
    <div class="Setdepartment_top">

      <el-form :inline="true" :model="formInline" ref="multipleTable">
        <el-form-item style="" label="量表名称">
          <el-input  v-model="PaperName" placeholder="量表名称" :clearable="true" @clear="removeall"></el-input>
        </el-form-item>
        <el-form-item class="cvbb">
          <el-button @click="screening" type="primary">筛选</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="Wait-test-content">
      <el-table v-loading="loadings" :data="tableData" style="width: 100%;">
        
        <el-table-column label="序号" align="center" min-width="6%">
          <template slot-scope="scope" center>
            {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column label="测试主题" min-width="20%">
          <template slot-scope="scope">
            <span>{{ scope.row.PubName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="量表名称" min-width="20%">
          <template slot-scope="scope">
            <span>{{ scope.row.PaperName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="账号" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.UserID }}</span>
          </template>
        </el-table-column>

        <el-table-column label="姓名" min-width="10%">
          <template slot-scope="scope">
            <span>{{ scope.row.RealName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="截止日期" align="center" min-width="10%">
          <template slot-scope="scope">
            {{ scope.row.ValidEndDate }}
          </template>
        </el-table-column>

        <el-table-column label="发布时间" align="center" min-width="18%">
          <template slot-scope="scope">
            {{ scope.row.CreatedDate }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="15%">

          <template slot-scope="scope">

            <el-button v-if="!scope.row.Forbidden"  size="mini" @click="handleEdit(scope.$index, scope.row)">
              开始测试
            </el-button>

            <el-button v-else size="mini" disabled>开始测试</el-button>

          </template>

        </el-table-column>

      </el-table>

      <div class="block">
        <el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page.sync="currentPage1"  :page-size="10"  layout="total, prev, pager, next"  :total="Counts"  :hide-on-single-page="wpppd"></el-pagination>
      </div>

    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      wpppd: true,
      pageIndex: 1,
      loadings: true,
      tableData: [],
      Counts: 0,
      currentPage1: 1,
      PaperName: '',
      formInline: {
        Name: '',
        Student: '',
        ScaleName: '',
        TestTime: '',
        PublishID: '',
        ObjectS: '',
        StudyTime: '',
        Warning: '',
      },
    }
  },
  methods: {
    handleEdit(index, row) {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      if (row.PaperID === 'EPQA' && year - moment(this.Global.birthday).year() < 16) {//成人版
        this.$message({type: 'error',message: '年龄小于16岁,请选择少年版'})
        return
      }
      if (row.PaperID === '(EPQC)' && year - moment(this.Global.birthday).year() > 15) {//少年版
        this.$message({type: 'error',message: '年龄大于16岁,请选择成人版'})
        return
      }
      if (row.PaperID === 'WAIS-RC_KJ') {
        this.$router.push({
          path: '/measurement/PaperTest_WebsterSpeech',
          query: { PaperID: row.PaperID, PublishID: row.PublishID, type: 1},
        })
      } else if (row.PaperID === 'WMS') {
        this.$router.push({
          path: '/measurement/PaperTest_WebsterMemory',
          query: { PaperID: row.PaperID, PublishID: row.PublishID, type: 1},
        })
      } else if (row.PaperID === 'WAIS-RC') {
        this.$router.push({
          path: '/measurement/PaperTest_WebsterAdult',
          query: { PaperID: row.PaperID, PublishID: row.PublishID, type: 1},
        })
      } else {
        this.$router.push({
          path: '/measurement/PaperTest',
          query: { PaperID: row.PaperID, PublishID: row.PublishID, type: 1},
        })
      }
    },
    handleDelete(index, row) {},
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.loading(val);
    },
    screening() {
      this.loading(1, this.PaperName);
    },
    resetForm() {
      this.PaperName = '';
    },
    loading(num, PaperName) {
      this.pageIndex = num;
      this.loadings = true;
      this.$Http_Post('ScaleIssue/GetLfzWaitText', {token: this.$cookies.get('token'),pageSize: '10',pageIndex: num,PaperName: PaperName,}).then((res) => {
        this.loadings = false;
        if (res.Code == 200 || res.Code == 0) {
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
        } else {
          this.Global.request_failure(res.Message);
          this.loading = false;
        }
      })
      .catch((err) => {
        this.$message({
          type: 'error',
          message: err.message,
        })
      })
    },
    removeall() {
      this.loading(1, '');
    },
  },
  mounted() {
    this.loading(1, '');
  },
}
</script>
<style>
.Waiting_test h2 {font-size: 20px;padding-bottom: 20px;}
.Waiting_test .block {float: right;margin-top: 6px;}
.Setdepartment_top {text-align: center;margin: 0 auto;}
.Setdepartment_top form {margin: 0 auto;}
.Wait-test-content {height: calc(100% - 62px);overflow: auto;}
.Waiting_test .el-input__inner {height: 36px;line-height: 36px;}
</style>
